import React, { useEffect, useRef, useState } from "react";
import { toast, ToastContainer } from "react-toastify";

import "common/css/master.css";

import Loader from "common/components/Loader";

import { allocateTeacherSvc } from "./teacherAllocationSvc";
import ManualAllocationSlider from "../teacherAllocationManual/manualAllocationSlider";


const TeacherAllocationHeader = (props) => {
    const { setLoader, setOpacity, updateKey } = props;

    const [isTeacherAllocationVisible, setIsTeacherAllocationVisible] = useState(false);

    const allocateManually = () => {
        // console.log("allocateManually called");
        setIsTeacherAllocationVisible(true);
    }

    const allocateTeacher = () => {
        // console.log("Allocate Teacher Called");
        // ask user "It will override all allocations including manual. Proceed?"
        if (window.confirm("It will override all allocations including manual. Proceed?")) {
            setLoader("block");
            setOpacity(0.5);
            allocateTeacherSvc(handleAllocateTeacherResponse);
        }
        else {
            // console.log("User cancelled the allocation");
            return false;
        }
    }

    const viewReport = () => {
        // console.log("View Report called");
        const newPageUrl = "/allocationReports";
        window.open(newPageUrl, '_blank');
    }

    const handleAllocateTeacherResponse = async (data) => {
        // console.log("handleAllocateTeacherResponse called, data", data);
        let obj = data;
        if (obj.status === 'Success') {
            toast.success(obj.message);
            updateKey();
        }
        else {
            if (obj.message == 'You are not logged in') {
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            }
            else if (obj.message == 'Your Session is expired, login again') {
                setTimeout(function () {
                    window.location.href = "/";
                }, 2000);
                return false;
            } else {
                toast.error(obj.message);
            }
        }
        setLoader("none");
        setOpacity(1);
    }

    const closeSlider = () => {
        setIsTeacherAllocationVisible(false);
    }


    return (
        <div className="col-md-12 col-xs-12 col-centered padding-remove " >
            <div className="col-md-12 col-xs-12 col-centered padding-remove " style={{ display: "flex", flexDirection: "row", justifyContent: "end", gap: "10px", margin: "20px 0 0 0" }} >
                <div style={{ width: "150px" }}>
                    <button type="button" style={{ width: "100%" }} className="btn btn-primary pull-right" onClick={(e) => { e.stopPropagation(); allocateTeacher(); }}>
                        Allocate Teacher
                    </button>
                </div>
                <div style={{ width: "150px" }}>
                    <button type="button" style={{ width: "100%" }} className="btn btn-primary pull-right" onClick={(e) => { e.stopPropagation(); allocateManually(); }}>
                        Allocate Manually
                    </button>
                </div>
                <div style={{ width: "120px" }}>
                    <button type="button" style={{ width: "100%" }} className="btn btn-primary pull-right" onClick={(e) => { e.stopPropagation(); viewReport(); }}>
                        View Report
                    </button>
                </div>
            </div>
            {
                isTeacherAllocationVisible ?
                    <div className="slider1-60">
                        <ManualAllocationSlider
                            closeSlider={closeSlider}
                        />
                    </div>
                    : null
            }
        </div>
    );
}

export default TeacherAllocationHeader;